module.exports = __webpack_public_path__ + "img/users.05815a6c.svg";